var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    {
      staticClass: "container-fluid planing-team-page",
      attrs: { role: "main" },
    },
    [
      _c(
        "article",
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c("h1", { staticClass: "mb-4" }, [
                _vm._v(_vm._s(_vm.$t("pages.planing-team.title"))),
              ]),
              _c(
                "div",
                { staticClass: "d-flex mb-4 p-2 table-responsive" },
                [
                  _c("employee-working-widget"),
                  _c("employee-vacations-widget", { staticClass: "ml-4" }),
                  _c("employee-sick-widget", { staticClass: "ml-4" }),
                  _c("employee-resting-widget", { staticClass: "ml-4" }),
                  _c("confirm-waiting-absence-widget", { staticClass: "ml-4" }),
                ],
                1
              ),
              _c("card-data-component", {
                staticClass: "mb-4",
                attrs: { tabs: _vm.tabs, currentTabKey: _vm.tabKey },
                on: _vm._d({}, [_vm.tabChangedEvent, _vm.tabChanged]),
                scopedSlots: _vm._u([
                  {
                    key: "data",
                    fn: function (props) {
                      return [
                        _vm.isGeneralTab(props.tab.key)
                          ? _c(
                              "div",
                              [
                                _c("general-search-component", {
                                  staticClass: "mb-4",
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isAbsenseTab(props.tab.key)
                          ? _c(
                              "div",
                              [
                                _c("absence-list-search-component", {
                                  staticClass: "mb-4",
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.isGeneralTab(_vm.tabKey) ? _c("plan-component") : _vm._e(),
          _vm.isWorkShiftTab(_vm.tabKey)
            ? _c("work-shift-list-component")
            : _vm._e(),
          _vm.isAbsenseTab(_vm.tabKey)
            ? _c("absences-list-component")
            : _vm._e(),
          _c("work-shift-detail-modal"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }